import React from 'react';
import { animated, useSpring } from '@react-spring/web';

const SlideDownMount = ({
  initialPosition = -4,
  destinationPosition = 0,
  position,
  ...rest
}: {
  initialPosition?: number;
  destinationPosition?: number;
  children?: any;
  position?: React.CSSProperties['position'];
}) => {
  const styles = useSpring({
    from: {
      y: initialPosition,
      opacity: 1,
      zIndex: 9999,
      position,
    },
    to: {
      y: destinationPosition,
      opacity: 1,
      zIndex: 9999,
    },
    delay: 0,
  });

  return <animated.div style={styles} {...rest} />;
};

export default SlideDownMount;
